import React, {useState} from 'react';
import {connect} from 'react-redux';
import './BulkInsert.scss';
import PropTypes from 'prop-types';
import {useHistory} from 'react-router';
import actions from '../../../redux/actions';
import Loading from '../../../common/components/Loading/Loading';
import Button from '../../../common/components/Button/Button';
import ArrowBackComponent from '../../../common/components/ArrowBack/ArrowBack';
import InfoTooltip from '../../../common/components/InfoTooltip/InfoTooltip';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {BULK_LOAD_ERRORS} from '../../../utils/consts';
import {CSVLink} from 'react-csv';

const ROLES = [
    {value: 'ADMIN', name: 'Administrador', branch: 'No lleva'},
    {value: 'USER', name: 'Usuario de sede', branch: 'Obligatoria'},
    {value: 'USER_VIEWER', name: 'Usuario de sede · Consulta', branch: 'Obligatoria'},
    {value: 'USER_QUOTER', name: 'Usuario de sede · Cotización', branch: 'Obligatoria'},
    {value: 'DEVELOPER', name: 'Desarrollador', branch: 'No lleva'},
];

const HELP_TEXT = 'Descargá la plantilla, completá una fila por usuario y subila como .csv. ' +
    'Se necesita el ID de Salesforce del prestador y, según el rol, el de la sede.';

const isCsv = (file) => file?.name?.toLowerCase().endsWith('.csv');

const formatSize = (bytes) => bytes < 1024 ? `${bytes} B` : `${Math.round(bytes / 1024)} KB`;

const errorMessage = (codes) => codes?.length ?
    codes.map((code) => BULK_LOAD_ERRORS[code] || code) :
    ['Ha ocurrido un error'];

const BulkInsert = (props) => {
    const {
        bulkInsert,
        bulkInsertState,
        bulkInsertResponse,
        cleanBulkInsert,
    } = props;

    const history = useHistory();

    const headers = [
        {label: '', key: ''},
        {label: 'email', key: 'email'},
        {label: 'name', key: 'name'},
        {label: 'cuitOrCuil', key: 'cuitOrCuil'},
        {label: 'phoneNumber', key: 'phoneNumber'},
        {label: 'phoneNumberType', key: 'phoneNumberType'},
        {label: 'salesforceProviderId', key: 'salesforceProviderId'},
        {label: 'salesforceBranchId', key: 'salesforceBranchId'},
        {label: 'role', key: 'role'},
        {label: 'verMontoValidador', key: 'verMontoValidador'},
    ];
    const templeteData = [
        {email: 'Ejemplo1@gmail.com', name: 'Ejemplo1', cuitOrCuil: '11-11111111-1', phoneNumber: '1111111111', phoneNumberType: 'PERSONAL', salesforceProviderId: 'a1lEa0000005D0lIAE', salesforceBranchId: '', role: 'ADMIN', verMontoValidador: ''},
        {email: 'Ejemplo2@gmail.com', name: 'Ejemplo2', cuitOrCuil: '11-11111111-2', phoneNumber: '1111111111', phoneNumberType: 'OFFICE', salesforceProviderId: 'a1lEa0000005D0lIAE', salesforceBranchId: 'a1rEa00000CPPghIAH', role: 'USER', verMontoValidador: 'true'},
        {email: 'Ejemplo3@gmail.com', name: 'Ejemplo3', cuitOrCuil: '11-11111111-3', phoneNumber: '1111111111', phoneNumberType: 'OTHER', salesforceProviderId: 'a1lEa0000005D0lIAE', salesforceBranchId: 'a1rEa00000CPPghIAH', role: 'USER_VIEWER', verMontoValidador: 'false'},
        {email: 'Ejemplo4@gmail.com', name: 'Ejemplo4', cuitOrCuil: '11-11111111-4', phoneNumber: '1111111111', phoneNumberType: 'OFFICE', salesforceProviderId: 'a1lEa0000005D0lIAE', salesforceBranchId: 'a1rEa00000CPPghIAH', role: 'USER_QUOTER', verMontoValidador: 'true'},
        {email: 'Ejemplo5@gmail.com', name: 'Ejemplo5', cuitOrCuil: '11-11111111-5', phoneNumber: '1111111111', phoneNumberType: 'OFFICE', salesforceProviderId: 'a1lEa0000005D0lIAE', salesforceBranchId: '', role: 'DEVELOPER', verMontoValidador: ''},
    ];

    const [file, setFile] = useState(null);
    const [dragging, setDragging] = useState(false);

    const selectFile = (selected) => {
        if (isCsv(selected)) setFile(selected);
    };

    const handleChange = (e) => {
        selectFile(e.target.files[0]);
        // Permite volver a elegir el mismo archivo despues de "Cambiar archivo"
        e.target.value = '';
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setDragging(true);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setDragging(false);
        selectFile(e.dataTransfer.files[0]);
    };

    const handleSubmit = () => {
        const formData = new FormData();
        formData.append('providers', file, file.name);
        bulkInsert(formData);
    };

    const goBack = () => {
        cleanBulkInsert();
        history.goBack();
    };

    const loadAnother = () => {
        cleanBulkInsert();
        setFile(null);
    };

    const helpTooltip = (
        <div className="bi-tooltip">
            <p>{HELP_TEXT}</p>
            <p><b>Roles válidos:</b> ADMIN, USER, USER_VIEWER, USER_QUOTER y DEVELOPER. ADMIN y DEVELOPER van sin sede.</p>
        </div>
    );

    const renderUpload = () => (
        <div className="bi-card">
            <div className="bi-step bi-step-row">
                <div className="bi-step-title">
                    <span className="bi-step-number subtitle-3">1</span>
                    <p className="subtitle-2 v2-c-text-title">Descargá la plantilla</p>
                </div>
                <CSVLink data={templeteData} headers={headers} filename="EjemploCsv.csv"
                         className="v2-button outlined medium subtitle-3 bi-download">
                    <FileDownloadOutlinedIcon fontSize="small"/> Descargar plantilla CSV
                </CSVLink>
            </div>

            <div className="bi-divider"/>

            <div className="bi-step">
                <div className="bi-step-title">
                    <span className="bi-step-number subtitle-3">2</span>
                    <p className="subtitle-2 v2-c-text-title">Subí el archivo completo</p>
                </div>
                {file ?
                    <div className="bi-file">
                        <div className="bi-file-icon"><InsertDriveFileOutlinedIcon/></div>
                        <div className="bi-file-info">
                            <p className="body-2 c-text-base">{file.name}</p>
                            <p className="body-4 c-text-subtitle">{formatSize(file.size)}</p>
                        </div>
                        <label className="bi-link subtitle-3">
                            Cambiar archivo
                            <input type="file" accept=".csv" onChange={handleChange}/>
                        </label>
                    </div> :
                    <label className={`bi-dropzone ${dragging ? 'dragging' : ''}`}
                           onDragOver={handleDragOver}
                           onDragLeave={() => setDragging(false)}
                           onDrop={handleDrop}>
                        <div className="bi-dropzone-icon"><CloudUploadOutlinedIcon/></div>
                        <p className="body-2 c-text-base">
                            Arrastrá tu archivo acá o <span className="bi-link-text">seleccioná uno</span>
                        </p>
                        <p className="body-4 c-text-subtitle">Solo archivos .csv</p>
                        <input type="file" accept=".csv" onChange={handleChange}/>
                    </label>
                }
            </div>

            <details className="bi-roles">
                <summary className="body-3 c-text-base">¿Qué roles puedo usar en la columna <code>role</code>?</summary>
                <div className="bi-roles-grid body-3">
                    <span className="bi-th">Valor</span>
                    <span className="bi-th">Rol</span>
                    <span className="bi-th">Sede</span>
                    {ROLES.map((role) => (
                        <React.Fragment key={role.value}>
                            <code>{role.value}</code>
                            <span>{role.name}</span>
                            <span>{role.branch}</span>
                        </React.Fragment>
                    ))}
                </div>
            </details>

            <div className="bi-actions">
                <button type="button" className="bi-text-button subtitle-3" onClick={goBack}>Cancelar</button>
                {/* Sin archivo no va la variante primary: en Button, .primary pisa el gris de .disabled */}
                <Button variant={file ? 'primary' : undefined} size="medium" disabled={!file} onClick={handleSubmit}>
                    Cargar usuarios
                </Button>
            </div>
        </div>
    );

    const renderResults = () => {
        const errors = [...(bulkInsertResponse?.errors || [])].sort((a, b) => a.index - b.index);
        const created = bulkInsertResponse?.response || [];
        const rowErrors = errors.filter((error) => error.index !== -1);
        const generalErrors = errors.filter((error) => error.index === -1);

        return (
            <div className="bi-results">
                {/* Con solo un error general (ej. encabezados) los contadores en 0 no aportan */}
                {(created.length > 0 || rowErrors.length > 0) &&
                <div className="bi-stats">
                    <div className="bi-card bi-stat">
                        <div className="bi-stat-icon success"><CheckCircleOutlineIcon/></div>
                        <div>
                            <p className="h3 v2-c-text-title">{created.length}</p>
                            <p className="body-3 c-text-subtitle">usuarios creados</p>
                        </div>
                    </div>
                    <div className="bi-card bi-stat">
                        <div className="bi-stat-icon error"><ErrorOutlineIcon/></div>
                        <div>
                            <p className="h3 v2-c-text-title">{rowErrors.length}</p>
                            <p className="body-3 c-text-subtitle">filas con errores</p>
                        </div>
                    </div>
                </div>
                }

                {generalErrors.map((error, index) => (
                    <div key={index} className="bi-general-error body-3">
                        <ErrorOutlineIcon fontSize="small"/> {errorMessage(error.codes).join(', ')}
                    </div>
                ))}

                {rowErrors.length > 0 &&
                    <div className="bi-card">
                        <p className="subtitle-1 v2-c-text-title">Filas con errores</p>
                        <div className="bi-table-container">
                            <table className="bi-table">
                                <thead><tr><th className="bi-col-row">Fila</th><th>Motivo</th></tr></thead>
                                <tbody>
                                    {rowErrors.map((error) => (
                                        <tr key={error.index}>
                                            <td className="subtitle-3">{error.index + 1}</td>
                                            <td>
                                                <div className="bi-chips">
                                                    {errorMessage(error.codes).map((message) =>
                                                        <span key={message} className="v2-chip chip-error body-4">{message}</span>,
                                                    )}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }

                {created.length > 0 &&
                    <div className="bi-card">
                        <p className="subtitle-1 v2-c-text-title">Usuarios creados</p>
                        <div className="bi-table-container">
                            <table className="bi-table">
                                <thead><tr><th>Nombre</th><th>CUIT / CUIL</th></tr></thead>
                                <tbody>
                                    {created.map((provider) => (
                                        <tr key={provider.id || provider.cuitOrCuil}>
                                            <td>{provider.name}</td>
                                            <td>{provider.cuitOrCuil}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                }

                <div className="bi-actions">
                    <Button variant="outlined" size="medium" onClick={loadAnother}>Cargar otro archivo</Button>
                    <Button variant="primary" size="medium" onClick={goBack}>Volver a Usuarios</Button>
                </div>
            </div>
        );
    };

    return (
        <div className="v2-bulk-insert">
            <div className="bi-header">
                <div className="bi-back">
                    <ArrowBackComponent onClick={goBack}/>
                </div>
                <p className="h3 v2-c-text-title">Carga masiva de usuarios</p>
                <span className="bi-help c-text-subtitle"><InfoTooltip title={helpTooltip}/></span>
            </div>
            {bulkInsertState.loading ?
                <Loading/> :
                bulkInsertState.success ? renderResults() : renderUpload()
            }
        </div>
    );
};

const mapStateToProps = (state) => ({
    bulkInsertState: state.home.bulkInsertState,
    bulkInsertResponse: state.home.bulkInsertResponse,
});

const mapDispatchToProps = (dispatch) => ({
    bulkInsert: (body) => dispatch(actions.home.bulkInsert(body)),
    cleanBulkInsert: () => dispatch(actions.home.cleanBulkInsert()),
});

BulkInsert.propTypes = {
    bulkInsert: PropTypes.func,
    bulkInsertState: PropTypes.object,
    bulkInsertResponse: PropTypes.object,
    cleanBulkInsert: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(BulkInsert);
